import { components } from '@doltech/dto';
import { TestStatusEnum, TestTypeEnum } from '@doltech/utils/lib/constants';
import { useStore } from 'mobx-store-provider';

import { getInitializeTestResultStore } from '../../student-test-result/model/test-result.hook';
import { ViewSolutionStore, ViewSolutionStoreInstance } from './view-solution.store';

export const getInitializeViewTestSolution = (
  data: components['schemas']['TestDetailDTO'] | components['schemas']['TestSectionDTO'],
  testType: TestTypeEnum
) => {
  let userTestData;
  if (testType === 'PRACTICE_TEST') {
    userTestData = {
      ...data,
      testType,
      testSection: { ...data },
      status: TestStatusEnum.COMPLETED,
    };
  } else {
    userTestData = {
      ...data,
      testType,
      test: { ...data },
      status: TestStatusEnum.COMPLETED,
    };
  }

  return getInitializeTestResultStore(userTestData);
};

export const useViewSolutionStore = (): ViewSolutionStoreInstance => {
  return useStore(ViewSolutionStore);
};
